<template>
  <transition name="fade">
    <div v-show="toastShow" class="toast">
      <img v-show="icon" class="icon" :src="icon" alt />
      <p v-show="toastString">{{ toastString }}</p>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import errorNetwork from './assets/network-err.svg';
import warn from './assets/warn.svg';
export interface IToast {
  icon?: string;
  value?: string;
  type?: string;
}
@Component({})
export default class Toast extends Vue {
  toastShow = false;
  toastString = '';
  icon = '';
  typeMap: any = {
    error_network: errorNetwork,
    warn: warn,
  };
  typeTipMap: any = {
    error_network: '网络连接失败',
    warn: '支付失败',
  };
  toast(conf: string | IToast) {
    this.unset();
    this.setup(conf);
    this.toastShow = true;
    setTimeout(() => {
      this.toastShow = false;
    }, 1500);
  }
  setup(conf: string | IToast) {
    if (typeof conf === 'string') {
      this.toastString = conf;
      return;
    }
    this.icon = conf.icon || '';
    this.toastString = conf.value || '';
    if (conf.type) {
      if (!this.icon) {
        this.icon = this.typeMap[conf.type] || '';
      }
      if (!this.toastString) {
        this.toastString = this.typeTipMap[conf.type] || '';
      }
    }
  }
  unset() {
    this.toastString = '';
    this.icon = '';
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  // padding: 40px 60px;
  z-index: 2005;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 360px;
  padding: 38px 60px;
  background: rgba($color: #000000, $alpha: 0.7);
  border-radius: 10px;
  transform: translate(-50%, -50%);
  .icon {
    width: 64px;
    height: 64px;
    margin-bottom: 12px;
  }
  p {
    color: #fff;
    font-weight: 500;
    font-size: 34px;
    text-align: center;
  }
}
</style>
